import { PropsWithChildren } from 'react';

type Provider = React.ComponentType<PropsWithChildren>;

const composeProviders =
  (...providers: Provider[]) =>
  ({ children }: PropsWithChildren) =>
    providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children
    );

export { composeProviders };
